<template>
    <div class="score relative flex-1">
        <Image class="score__image content content--full-mobile" :src="scoreImage" />
        <div class="message content">
            <div class="wrapper">
                <div class="greet flex items-center justify-between"
                :style="`color: var(${color})`">
                    <LeftColoredDots />
                    <h2 v-if="score === 'bad'">O, nu!</h2>
                    <h2 v-else-if="score === 'average'">Ești pe val!</h2>
                    <h2 v-else>Felicitări!</h2>
                    <RightColoredDots />
                </div>
                <template v-if="score === 'bad'">
                    <h1>EȘTI RELAXAT CA UN KOALA KOOL!</h1>
                    <div class="space-y-3">
                        <p class="text-center">Cu {{scoreValue}}/12 răspunsuri corecte, îți mai trebuie niște lecții de Kung-fu online.</p>
                        <p class="text-center">E ok că te simți bine online, că vezi mereu partea plină a paharului, dar asta te face țintă sigură pentru infractorii online. Contează pe încrederea ta, pe lipsa de atenție sau de cunoștințe pentru a-ți fura banii de pe card, accesul la conturi, date personale sau informații și fotografii pe care nu le-ai vrea publice.</p>
                        <p class="text-center"><strong>Sfatul nostru</strong>: informează-te cât mai bine despre pericolele online, fii mereu vigilent și vei rămâne în siguranță!</p>
                    </div>
                </template>
                <template v-if="score === 'average'">
                    <h1>EȘTI VIGILENT CA UN SURFER PRINTRE RECHINI!</h1>
                    <div class="space-y-3">
                        <p class="text-center">Cu {{scoreValue}}/12 răspunsuri corecte, te păzești și te ferești chiar bine.</p>
                        <p class="text-center">Se vede că știi câte ceva despre ce înseamnă siguranța online, dar mai ai puțin de lucrat. E bine că ești atent la pericole, că încerci să nu cazi în plasa ”prădătorilor” online, iar singurul lucru care-ți rămâne de făcut este să te informezi în plus. Așa îți vei proteja cât mai bine cardul, conturile, datele personale și fotografiile.</p>
                    </div>
                </template>
                <template v-if="score === 'good'">
                    <h1>EȘTI AGIL CA BATMAN!</h1>
                    <div class="space-y-3">
                        <p class="text-center">Cu {{scoreValue}}/12 răspunsuri corecte, poți să-i salvezi și pe cei din jur de periocolele online.</p>
                        <p class="text-center">Felicitări! Se vede că ești pregătit pentru orice amenințare online. Datorită cunoștințelor, încrederii și atenției la detalii, niciun pericol nu te prinde nepregătit. Dintr-o mișcare, blochezi cu eleganță orice element suspect, astfel că ții mereu în siguranță cardul, conturile, datele personale și fotografiile. Învață-i și pe prietenii tăi să facă la fel!</p>
                    </div>
                </template>

                <Button autofocus @click.prevent="resetQuiz" class="mt-16">Încearcă din nou</Button>
            </div>
        </div>
        <div class="c2a">
            <h2 class="text-center">
                <span class="text-white">Share</span> cu prietenii tăi
                <p v-if="copyVisible" class="text-sm">Url-ul a fost copiat.</p>
            </h2>
        </div>
        <div class="share flex justify-center">
            <a href="https://www.facebook.com/sharer/sharer.php?u=kids.sigurantaonline.ro" target="_blank" class="social"><div class="flex items-center justify-center"><Facebook /></div></a>
            <a href="whatsapp://send?text=Știi să rămâi în siguranță online? Ești relaxat, vigilent sau agil? Știi să-ți ții cardul, conturile și propria imagine la adăpost de orice pericol? E mai tricky decât crezi! Răspunde la întrebări și vezi ce scor de siguranță obții! https://kids.sigurantaonline.ro" class="social"><div class="flex items-center justify-center"><Whatsapp /></div></a>
            <a @click.prevent="copyLink" href="#" class="social"><div class="flex items-center justify-center"><Link /></div></a>
        </div>
    </div>
</template>

<script>
import copy from "copy-to-clipboard";

import User from "../Modules/User";
import Button from "../Common/Button.vue";

import Image from "./Image.vue";
import Facebook from "./Vector/Facebook.vue";
import Whatsapp from "./Vector/Whatsapp.vue";
import Link from "./Vector/Link.vue";
import LeftColoredDots from "./Vector/LeftColoredDots.vue";
import RightColoredDots from "./Vector/RightColoredDots.vue";
export default {
	name: "ScoreShare",
	data: () => ({
		copyVisible: false
	}),
	components: {
        Button,
		RightColoredDots,
		LeftColoredDots,
		Link,
		Whatsapp,
		Facebook,
		Image
		// Share
	},
	props: {
		user: User,
		quizType: {
			type: String,
			default: "banking"
		},
	},
	emits: ["reset"],
	computed: {
		scoreValue() {
			return this.user.score;
		},
		score() {
			if (this.scoreValue >= 11) {
				return "good";
			}
			if (this.scoreValue >= 8) {
				return "average";
			}
			return "bad";
		},
		scoreImage() {
			switch (this.score) {
			case "good":
				return "/img/illustrations/final_batman.png";
			case "average":
				return "/img/illustrations/final_surfer.png";
			default:
				return "/img/illustrations/final_koala.png";
			}
		},
		color() {
			switch (this.score) {
			case "good":
				return "--green";
			case "average":
				return "--light-blue";
			default:
				return "--red";
			}
		}
	},
	methods: {
		resetQuiz() {
			this.$emit("reset");
		},
		copyLink() {
			copy("https://kids.sigurantaonline.ro");
			this.copyVisible = true;
			setTimeout(() => this.copyVisible = false, 3000);
		},
		gotoHomepage(e) {
			e.preventDefault();
			document.location.href = "https://sigurantaonline.ro";
		},
		addLogoClickEvent() {
			const element = document.querySelector("header .logo");
			element?.addEventListener("click", (e) => this.gotoHomepage(e));
		},
		removeLogoClickEvent() {
			const element = document.querySelector("header .logo");
			element?.removeEventListener("click", (e) => this.gotoHomepage(e));
		}
	},
	mounted() {
		this.user.reset("kids");
		document.body.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
		this.addLogoClickEvent();
	},
	beforeUnmount() {
		this.removeLogoClickEvent();
	}
};
</script>

<style lang="scss">
.score {
    --message-spacing: -5% 0 0 0;
    --message-width: 100%;
    --greeting-size: 20px;
    --greeting-leading: 24px;
    --greeting-spacing: 0 20px;
    --title-size: 24px;
    --title-leading: 30px;
    --title-spacing: 30px 0 10px;
    --paragraph-size: 14px;
    --paragraph-leading: 22px;
    --c2a-spacing: 60px 0 20px;
    --c2a-size: 20px;
    --c2a-leading: 24px;
    --c2a-width: 280px;
    --padding: 56px 35px;
    --border: 2px solid #000000;
    --border-radius: 10px;
    --message-shadow: 6px 6px 18px rgba(0, 0, 0, 0.2);
    --share-size: 50px;
    --share-spacing: 26px;
    --share-border: 2px solid #000000;
    --share-border-radius: 10px;
    --social-spacing: 0 0 50px;
    --share-shadow-offset: 6px;


    @media (min-width: 1024px) {
        --message-spacing: -5% 0 0 0;
        --message-width: 80%;
        --greeting-size: 30px;
        --greeting-leading: 38px;
        --title-size: 38px;
        --title-leading: 46px;
        --title-spacing: 35px 0 10px;
        --paragraph-size: 18px;
        --paragraph-leading: 26px;
        --c2a-spacing: 60px 0 30px;
        --c2a-size: 30px;
        --c2a-leading: 38px;
        --c2a-width: 420px;
        --padding: 77px 60px;
        --border: 4px solid #000000;
        --border-radius: 20px;
        --message-shadow:  10px 10px 26px rgba(0, 0, 0, 0.15);
        --share-size: 60px;
        --share-spacing: 30px;
        --share-border: 4px solid #000000;
        --share-border-radius: 10px;
        --social-spacing: 0 0 100px;
        .score__image {
            max-width: 400px !important;
            margin-left: auto;
            margin-right: auto;
        }
    }

    .score__image {
        max-width: 300px !important;
        margin-left: auto;
        margin-right: auto;
    }

    .message {
        position: relative;
        margin: var(--message-spacing);
        z-index: 2;
        .wrapper {
            border: var(--border);
            border-radius: var(--border-radius);
            padding: var(--padding);
            background: white;
            text-align: center;
            width: var(--message-width);
            margin: 0 auto;
            box-shadow: var(--message-shadow);

            h1, h2 {
                text-transform: uppercase;
                font-weight: 900;
            }

            h1 {
                font-size: var(--title-size);
                line-height: var(--title-leading);
                margin: var(--title-spacing);
            }

            h2 {
                font-size: var(--greeting-size);
                line-height: var(--greeting-leading);
                margin: var(--greeting-spacing);
                flex: 0 0 auto;
            }

            p {
                font-size: var(--paragraph-size);
                line-height: var(--paragraph-leading);
            }
        }
    }

    .c2a {
        margin: var(--c2a-spacing);
        h2 {
            font-size: var(--c2a-size);
            line-height: var(--c2a-leading);
            font-weight: 900;
            max-width: var(--c2a-width);
            margin: 0 auto;
            text-transform: uppercase;
        }
    }

    .share {
        margin: var(--social-spacing);
        gap: var(--share-spacing);
        .social {
            position: relative;
            cursor: pointer;
            color: black;
            & > div {
                width: var(--share-size);
                height: var(--share-size);
                border: var(--share-border);
                border-radius: var(--share-border-radius);
                background: white;
                position: relative;
                z-index: 1;
                transition: transform .3s;
            }
            &:after {
                content: "";
                display: block;
                position: absolute;
                top: var(--share-shadow-offset);
                left: var(--share-shadow-offset);
                width: 100%;
                height: 100%;
                background: var(--yellow);
                border: var(--share-border);
                border-radius: var(--share-border-radius);
            }
            &:hover {
                color: var(--light-blue);
                transition: color .3s;
            }
            &:active {
                & > div {
                    transform: translate(var(--share-shadow-offset), var(--share-shadow-offset));
                }
            }
        }
    }
}
</style>
